require('./comparisons.scss');
const $ = require("jquery");
$('.watch-demo-button').on('click', (e) => {
    $('.w-big-play-button').trigger('click');
})